/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTagsRequest} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/tag.pb'
import {GetTagsResponse} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/tag.pb'


export const getTags = (request: GetTagsRequest, options?: CashRequestOptions) => post<GetTagsRequest, GetTagsResponse>("/2.0/cash/get-tags", request, {...options, rejectOnError: true })